var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#98918A",
  d: "M5.192 5.723V4.34c0-.208.01-.369.029-.482a.937.937 0 0 1 .131-.337.538.538 0 0 1 .332-.229 2.36 2.36 0 0 1 .61-.063h1.383V.459H5.465c-1.28 0-2.2.304-2.76.912-.558.607-.837 1.503-.837 2.685v1.667H.21v2.769h1.657v8.032h3.325V8.492h2.212l.293-2.769H5.192Z"
})));
export default SvgFacebook;